const Label = ({ text, name, required, hasError }) => {
  return (
    <label
      htmlFor={name}
      style={{
        fontSize: 14,
        fontWeight: 400,
        lineHeight: 1.14,
        color: hasError ? "red" : "rgba(144, 149, 173, 0.9)",
        marginBottom: 10,
      }}
    >
      {text} {required ? <span>*</span> : ""}
    </label>
  );
};

export default Label;
